import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import ClassSubjectMapping from "./routes/ClassSubjectMapping";
import GradebookLogs from "./routes/GradebookSyncLogs";
import GradingPeriodMapping from "./routes/GradingPeriodMapping";

export default store => ({
  path: "term-grade",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    GradebookLogs(store),
    ClassSubjectMapping(store),
    GradingPeriodMapping(store),
  ],
});
